<div class="flex flex-col gap-1" data-test-id="filter-search">
	<span class="font-semibold">
		{{ 'compositions.filters.search.title' | translate }}
	</span>
	<vp-autocomplete
		[loading]="loading()"
		[minimumCharacters]="minimumCharacters"
		[options]="options()"
		[selectedOption]="selectedOption()"
		(searched)="onSearched($event)"
		(selectedValue)="onSelected($event)"
		loadingText="compositions.filters.search.loading"
		placeholder="compositions.filters.search.placeholder"
	/>
</div>
